// Plate barcodes are RUN_PLATECODE_SERIES, e.g. QCT254_QC12W_101
export const getRunIdFromPlateBarcode = (plateBarcode: string): string =>
  plateBarcode.split("_")[0];

export const getPlateCodeFromPlateBarcode = (plateBarcode: string): string =>
  plateBarcode.split("_")[1] ?? "";
